import { addDays, formatWeekday } from '../lib/format.js'
import type { OverlayTask } from './shell.js'

/**
 * A one-glance week ahead. Answers the question a worker actually asks:
 * "do I have anything on Thursday?", without leaving the screen they are on.
 */
export function WeekStrip({
  today,
  byDay,
  selected,
  days = 10,
  loading,
  onSelect,
}: {
  today: string
  byDay: Map<string, OverlayTask[]>
  selected?: string
  days?: number
  loading?: boolean
  onSelect: (date: string) => void
}) {
  const dates = Array.from({ length: days }, (_, index) => addDays(today, index))

  return (
    <div className="wk-strip" role="group" aria-label="Nächste Tage">
      {dates.map((date) => {
        const tasks = byDay.get(date) ?? []
        const open = tasks.filter((task) => task.status !== 'done').length
        const missed = tasks.some((task) => task.status === 'missed')
        const allDone = tasks.length > 0 && open === 0

        return (
          <button
            key={date}
            type="button"
            aria-pressed={selected === date}
            className={[date === today ? 'today' : '', missed ? 'has-missed' : '', allDone ? 'all-done' : '']
              .filter(Boolean)
              .join(' ')}
            onClick={() => onSelect(date)}
          >
            <span className="wd">{formatWeekday(date)}</span>
            <span className="dn">{Number(date.slice(8))}</span>
            {/* A dash would claim "nothing planned" before the data has arrived. */}
            <span className="ct">{loading ? '…' : tasks.length === 0 ? '–' : allDone ? '✓' : open}</span>
          </button>
        )
      })}
    </div>
  )
}
